import { SettingsOutlined } from '@mui/icons-material';
import { ControlButton, ControlButtonActivityStatus, ControlButtonProps } from './ControlButton.component';

export type SettingsControlButtonProps = Pick<ControlButtonProps, 'onToggleActive'>;

export const SettingsControlButton: React.VFC<SettingsControlButtonProps> = (props) => {
  const activityStatus: ControlButtonActivityStatus = {
    icon: <SettingsOutlined />,
    tooltipTitle: 'Settings',
  };

  return (
    <ControlButton
      enabled={activityStatus}
      disabled={activityStatus}
      isActive
      {...props}
    />
  );
};